export default "__VITE_ASSET__4fd71510__"